import React, { useState } from "react";

const ReceiptPrefixModal = ({ onClose }) => {
  const [prefix, setPrefix] = useState("");
  const [receiptNo, setReceiptNo] = useState("");

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
      <div className="bg-white w-full max-w-sm p-6 rounded-xl shadow-xl relative">
        <button
          onClick={onClose}
          className="absolute top-3 right-4 text-red-500 text-xl font-bold"
        >
          ×
        </button>
        <h3 className="text-lg font-semibold mb-4">Receipt Prefix & Count</h3>

        <label className="block mb-1">Prefix</label>
        <input
          type="text"
          className="input mb-4"
          value={prefix}
          onChange={(e) => setPrefix(e.target.value)}
        />

        <label className="block mb-1">Receipt No</label>
        <input
          type="text"
          className="input mb-2"
          value={receiptNo}
          onChange={(e) => setReceiptNo(e.target.value)}
        />

        <p className="text-xs text-gray-500 mb-4">
          Note: Bill number will be +1. E.g., if set to 1000, the next bill will be 1001.
        </p>

        <div className="flex gap-3">
          <button className="w-full py-2 bg-gray-300 rounded">Generate Random</button>
          <button className="w-full py-2 bg-primary text-white rounded">Save</button>
        </div>
      </div>
    </div>
  );
};

export default ReceiptPrefixModal;
